// texe-web/src/context/PostInteractionsProvider.tsx
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { usePostInteractions } from '../hooks/usePostInteractions';
import type { UsePostInteractionsReturn } from '../hooks/usePostInteractions';

/**
 * Global Post Interactions Context
 * Tüm sayfalar aynı like/comment state'ini paylaşır
 */
const PostInteractionsContext = createContext<UsePostInteractionsReturn | null>(null);

export function PostInteractionsProvider({ children }: { children: ReactNode }) {
  const postInteractions = usePostInteractions();
  
  return (
    <PostInteractionsContext.Provider value={postInteractions}>
      {children}
    </PostInteractionsContext.Provider>
  );
}

/**
 * Global post interactions hook'u
 * Her sayfada aynı state'i kullanır
 */
export function useGlobalPostInteractions(): UsePostInteractionsReturn {
  const context = useContext(PostInteractionsContext);
  if (!context) {
    throw new Error('useGlobalPostInteractions must be used within PostInteractionsProvider');
  }
  return context;
}
